import React from 'react'
import '../css/main.scss'
import { MdContentCopy } from 'react-icons/md';
import CopyToClipboard from "react-copy-to-clipboard"

import jpg_systemOverview from '../assets/images/systemOverview.jpg'
import jpg_usResults from '../assets/images/UserStudyResults.jpg'

var myBibTex = `@inproceedings{10.1145/3410700.3425425,
    author = {Kumazaki, Tomoya and Nakashima, Kazutaka and Fukusato, Tsukasa and Igarashi, Takeo},
    title = {HedgehogAD: Interactive Design Exploration of Omni-Directional Aerodynamics},
    year = {2020},
    isbn = {9781450380805},
    publisher = {Association for Computing Machinery},
    address = {New York, NY, USA},
    url = {https://doi.org/10.1145/3410700.3425425},
    doi = {10.1145/3410700.3425425},
    abstract = { OmniAD&nbsp;[Martin et&nbsp;al. 2015] is a data-driven pipeline for physics-based aerodynamics animations. In the pipeline, a real-time aerodynamic model which handles omni-directional airflow has also been introduced. However, their framework requires a captured motion, which implies that their model is not suitable for designing a customized motion. In this paper, we present a method to add user-controllability to the aerodynamic model in OmniAD by allowing the user to directly interact with the aerodynamics model. The system first visualizes the force and torque coefficients, which represent (x, y, z) components of aerodynamic force (i.e.,&nbsp;drag and lift force) and torque, as a set of arrows on a sphere. The user then modifies the arrows on the screen as desired. The system updates the internal representation (parameters for spherical harmonics) and shows resulting animation. We run a user study and the participants successfully designed physically plausible falling motions using the proposed method.},
    booktitle = {SIGGRAPH Asia 2020 Technical Communications},
    articleno = {13},
    numpages = {4},
    keywords = {Controllability, Omni-directional aerodynamics, Falling animation},
    location = {Virtual Event, Republic of Korea},
    series = {SA '20}
    }`



const Main = () => {
    // let isNotification: boolean = false;
    // let showNotification = () => {
    //     console.log(isNotification);
    //     setTimeout(() => { isNotification = false; console.log(isNotification); }, 5000)
    //     isNotification = true;
    // }


    return (
        <div>
            <main>
                <div className='Heading'>
                    <div className="Heading-submissions"><strong>SIGGRAPH Asia 2020 <span className="Nonbreak">Technical Communications</span></strong></div>
                    <h1 className="Heading-title">
                        HedgehogAD : Interactive Design Exploration of <span className="Nonbreak">Omni-Directional</span> Aerodynamics
                    </h1>
                    <div className='Heading-author'>
                        <p>Tomoya Kumazaki </p>
                        <p><a href="https://n-taka.info/intro/" target="_blank" rel="noreferrer noopener">Kazutaka Nakashima</a></p>
                        <p><a href="https://sites.google.com/view/tsukasafukusato" target="_blank" rel="noreferrer noopener">Tsukasa Fukusato</a></p>
                        <p><a href="https://www-ui.is.s.u-tokyo.ac.jp/~takeo/" target="_blank" rel="noreferrer noopener">Takeo Igarashi</a></p>
                    </div>
                    <div className="Heading-affiliation">The University of Tokyo</div>

                    <div className="Heading-images">
                        <div className="Heading-images-item">
                            <img src={jpg_systemOverview} alt="System Over View"></img>
                        </div>
                        <div className="Heading-images-item">
                            <img src={jpg_usResults} alt="User Study Results"></img>
                        </div>

                    </div>
                </div >

                <hr></hr>

                <div className='Abstract'>
                    <h2>Abstract</h2>
                    <p>
                        <a href="https://dl.acm.org/doi/pdf/10.1145/2766919" target="_blank" rel="noreferrer noopener">
                            OmniAD [Martin et al. 2015]
                        </a> is a data-driven pipeline for physics-based aerodynamics animations. In the pipeline, a real-time aerodynamic model which handles omni-directional airflow has also been introduced. However, their framework requires a captured motion, which implies that their model is not suitable for designing a customized motion.
                    </p>
                    <div className="Space"></div>
                    <p>
                        In this paper, we present a method to add user-controllability to the aerodynamic model in OmniAD by allowing the user to directly interact with the aerodynamics model. The system first visualizes the force and torque coefficients, which represent (x,y,z) components of aerodynamic force (i.e., drag and lift force) and torque, as a set of arrows on a sphere. The user then modifies the arrows on the screen as desired. The system updates the internal representation (parameters for spherical harmonics) and shows resulting animation. We run a user study and the participants successfully designed physically plausible falling motions using the proposed method.
                    </p>
                </div>

                <hr></hr>

                <div className='Links'>
                    <h2>Links</h2>
                    <ul>
                        <li>Paper [ <a href={process.env.PUBLIC_URL + '/HedgehogAD.pdf'} target="_blank" rel="noreferrer noopener">PDF(1.5MB)</a> / <a href="https://dl.acm.org/doi/10.1145/3410700.3425425" target="_blank" rel="noreferrer noopener">ACM DL</a> ]</li>
                        <li>BibTex
                                <CopyToClipboard text={myBibTex} onCopy={() => { }}>
                                <span className='Icon'> <MdContentCopy size={20} style={{ verticalAlign: 'middle' }} /></span>
                            </CopyToClipboard>
                            {/* <span className="Notification" style={{ display: isNotification ? 'block' : 'none' }}>
                                <span>Copied to Clipboard!</span>
                            </span> */}
                        </li>
                    </ul>
                </div>

                <hr></hr>
                <div className='Video'>
                    <h2>Presentation Video</h2>
                    <div className="SupVideo">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/eQwAxx7irUs" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="HedgehogAD Presentation Video"></iframe>
                    </div>

                </div>

                <hr></hr>

                <div className='Video'>
                    <h2>Supplemental Video</h2>
                    <div className="SupVideo">
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/Ky8Hwd5MOFw" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title="HedgehogAD Supplemental Video"></iframe>
                    </div>
                </div>

                <hr></hr>

                <div className='Acknowledgement'>
                    <h2>Acknowledgement</h2>
                    <p>We would like to thank <a href="https://cgenglab.github.io/labpage/en/" target="_blank" rel="noreferrer noopener">
                        Nobuyuki Umetani
                        </a> for many insightful discussions.
                        This work was supported by JST CREST under grant JPMJCR17A1.
                    </p>
                </div>
            </main>
        </div >
    )
}

export default Main